import {
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureFlagsV2Service } from 'src/app/core/services/feature-flags.v2.service';

@Directive({
  selector: '[appFeatureFlagDisabled]',
})
export class FeatureFlagDisabledDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private featureFlagService = inject(FeatureFlagsV2Service, {
    optional: true,
  });
  private destroy$ = new Subject<void>();
  private hasView = false;

  @Input('appFeatureFlagDisabled') flagName!: string;

  ngOnInit(): void {
    if (!this.flagName) {
      console.error('FeatureFlagDisabledDirective: No flag name provided.');
      return;
    }

    // If the feature flag service is absent (e.g. in simple unit tests), don't render by default.
    // This is opposite behavior from appFeatureFlag to avoid needing mocks in tests.
    if (!this.featureFlagService) {
      this.clearView();
      return;
    }

    this.featureFlagService
      .isEnabled(this.flagName)
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        if (!isEnabled) {
          // Show content when flag is disabled or not present
          this.ensureView();
        } else {
          this.clearView();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private ensureView(): void {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  private clearView(): void {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
